import { es, enGB, fr, ca } from "date-fns/locale";
import { Locale } from "date-fns";

export const LOCALES: Record<string, Locale> = {
    es,
    en: enGB,
    fr,
    ca,
};